<template>
  <div class="card">
    <div class="card-header">
      <h1 class="card-title">
        Expert Pending Payments
      </h1>
    </div>

    <div class="card-body">
      <div class="mb-3">
        <b-spinner
          v-if="fetchingPendingList"
          type="grow"
          variant="primary"
        />
        <payment-request-date-filter
          :start-date="startDate"
          :end-date="endDate"
          @update-date-range="updateDateRange"
        />
      </div>

      <payment-request-list-table
        :request-list="pendingList"
        :editable="editable"
        :start-date="startDate"
        :end-date="endDate"
        @fetch-requests="getPendingList"
      />
    </div>
  </div>
</template>

<script>
import PaymentRequestListTable from "./elements/PaymentRequestListTable.vue";
import PaymentRequestDateFilter from "./elements/PaymentRequestDateFilter.vue";
import moment from "moment-timezone";

export default {
    name: "ExpertPendingPaymentList",
    components: {PaymentRequestDateFilter, PaymentRequestListTable},
    props: {
        editable: {
            type: Boolean,
            default: false
        },
        startDate: {
            type: String,
            required: false,
            default: ''
        },
        endDate: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function () {
        return {
            pendingList: [],
            fetchingPendingList: false
        }
    },
    mounted() {
        this.getPendingList()
    },
    methods: {
        updateDateRange(start, end) {
            this.getPendingList(start, end)
        },
        async getPendingList(startDate, endDate) {
            try {
                this.fetchingPendingList = true
                const result = (await axios.get('/admin/credit-tracking/api/pending-experts', {
                    params : {
                        'start_date': startDate,
                        'end_date': endDate
                    }
                }))
                this.pendingList = result.data.data
            } catch (error) {
                console.log(error);
            } finally {
                this.fetchingPendingList = false
            }
        }
    }
}
</script>
